import React from 'react';
import { Spinner } from '@surfline/quiver-react';

const OfferLoading = () => (
  <div className="offer-loading">
    <div className="offer-loading__message">
      {'The details of your offer are being calculated.  This could take a few seconds.  Please standby.'}
    </div>
    <Spinner />
  </div>
);

export default OfferLoading;
